import { Navigate, Outlet, useLocation, useOutletContext, useParams } from 'react-router-dom'

import Loading from '@hapana/shared/web/components/shared/loading/loading.component'
import { PageSkeleton } from '_components/page-skeletons'
import { REDIRECT_PARAM } from '_constants/kb-links.constants'
import useAuthStore from '_stores/auth.store'
import { usePermissions } from '_stores/permissions.store'
import { isDeskSessionLocked, useDeskSessionLockStore } from '_stores/desk-session-lock.store'
import { useDeskSessionLockSync } from '_hooks/use-desk-session-lock-sync.hook'
import DeskSessionLock from '_pages/pending-items/components/desk-session-lock.component'

const RequireAuth = () => {
  const location = useLocation()
  const params = useParams()
  const isQuickSearch = useOutletContext()
  const permissionsStore = usePermissions()
  const isDeskLocked = useDeskSessionLockStore(isDeskSessionLocked)
  useDeskSessionLockSync()

  const { user, idToken, loading, initialized, headersReady } = useAuthStore()
  const hasValidSession = !!user && !!idToken

  const isLoading = loading || !initialized || (initialized && !headersReady)

  if (isLoading) {
    return <PageSkeleton />
  }

  if (!hasValidSession) {
    // Demo users: Firebase auth may still be resolving after tenant switch
    // (onIdTokenChanged briefly fires with null during tenant init).
    // If the demo-authenticated flag is set, keep showing loading instead of redirecting.
    const hasDemoSession = sessionStorage.getItem('demo-authenticated') === 'true'
    if (hasDemoSession) {
      return <Loading />
    }

    const { corporateSlug } = params
    const basePath = corporateSlug ? `/${corporateSlug}/login` : '/login'
    const target = `${location.pathname}${location.search || ''}`
    // state.from is lost on a cold page load, so the destination also rides the query string.
    const loginPath = `${basePath}?${REDIRECT_PARAM}=${encodeURIComponent(target)}`
    return <Navigate to={loginPath} state={{ from: location }} replace />
  }

  if (isDeskLocked) {
    return <DeskSessionLock />
  }

  return !isQuickSearch ? <Outlet context={{ ...permissionsStore, isQuickSearch }} /> : <Loading />
}

RequireAuth.propTypes = {}

export default RequireAuth
